import { useState, useEffect } from 'react';

import { List, Avatar, Skeleton, Empty } from 'antd';
import type { PromptDefinition } from '~/services';
import { useGetPromptsTemplates } from '~/hooks';

export function SuggestedPrompts({
    cardsList,
    onCardClick,
}: {
    cardsList: any[];
    onCardClick: any;
}) {
    return <PromptsList cards={cardsList} onCardClick={onCardClick} />;
}

export function PromptsHistoryList({ onClick }) {
    const [isFetching, setFetching] = useState(false);
    const [prompts, setPrompts] = useState([]);
    const promptsTemplates = useGetPromptsTemplates();

    useEffect(() => {
        const fetchPrompts = async () => {
            const res = await fetch('/prompts-history', {
                method: 'POST',
            });

            if (res.status !== 200) {
                return { prompts: [] };
            }

            const response = await res.json();
            return response;
        };

        const init = async () => {
            setFetching(true);
            const { prompts } = await fetchPrompts();
            setPrompts(prompts);
            setFetching(false);
        };

        init();
    }, [setFetching, setPrompts]);

    if (prompts.length === 0 && isFetching) {
        return (
            <div className='w-full h-full overflow-hidden p-2'>
                <Skeleton active />
            </div>
        );
    }

    if (prompts.length === 0) {
        return (
            <div className='w-full h-full overflow-hidden p-2'>
                <Empty />
            </div>
        );
    }

    const cardsList = prompts
        .filter((p) => promptsTemplates.some((t) => t.id === p.promptId))
        .map((p) => {
            const t = promptsTemplates.find((t) => t.id === p.promptId);

            return {
                ...t,
                description: p.prompt?.slice(0, 500),
                userPrompt: p.prompt,
            };
        });

    return (
        <div className='w-full h-full'>
            <PromptsList cards={cardsList} onCardClick={onClick} />
        </div>
    );
}

function PromptsList({ cards, onCardClick }) {
    return (
        <List
            className='w-full h-full !p-2 overflow-y-auto'
            itemLayout='horizontal'
            dataSource={cards}
            renderItem={(card: any, index) => (
                <List.Item
                    className='cursor-pointer group'
                    key={`card-${index}`}
                    onClick={() => onCardClick(card)}>
                    <List.Item.Meta
                        avatar={
                            <Avatar
                                className='group-hover:scale-110 duration-300 transition ease-in-out'
                                size={64}
                                style={{ backgroundColor: '#91caff' }}>
                                <span className='text-3xl'>{card.emoji}</span>
                            </Avatar>
                        }
                        title={
                            <span className='group-hover:scale-110 duration-300 transition ease-in-out'>
                                {card.title}
                            </span>
                        }
                        description={card.description}
                    />
                </List.Item>
            )}
        />
    );
}

export default function CardsGridView({
    cards,
    onClick,
}: {
    cards: Array<PromptDefinition>;
    onClick: (prompt: PromptDefinition) => void;
}) {
    return <PromptsList cards={cards} onCardClick={onClick} />;
}
